import React from 'react';
import { useLocation, useOutlet } from 'react-router-dom';
import { AnimatePresence } from 'motion/react';

/**
 * Renders the current child route element (edit slideout, edit dialog) inside
 * an AnimatePresence so the slideout transitions in/out cleanly. Keying on
 * the route pathname makes `<AnimatePresence>` swap when the user navigates
 * between two adjacent edit URLs (e.g. row → row) so the slideout remounts
 * with the new data.
 */
export function LibraryListOutlet() {
  const outlet = useOutlet();
  const location = useLocation();
  return (
    <AnimatePresence>
      {outlet && React.cloneElement(outlet, { key: location.pathname })}
    </AnimatePresence>
  );
}
